import PromoCode from '../apis/promocode';

const state = {};
const actions = {
    updatePromoCode({ commit }, data) {
        return PromoCode.show(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    promocodeRedeem({ commit }, data) {
        return PromoCode.couponRedeem(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    getPromoCodesData({ commit }, data) {
        return PromoCode.getPromoCodes(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    
    getRedeemPromocodeData({ commit }, data) {
        return PromoCode.getRedeemPromocode(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    giftVoucherListData({ commit }, data) {
        return PromoCode.giftVoucherList(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    giftVoucherSelectData({ commit }, data) {
        return PromoCode.giftVoucherSelect(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    giftVoucherRedeemData({ commit }, data) {
        return PromoCode.giftVoucherRedeem(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    
    giftVoucherHistoryData({ commit }, data) {
        return PromoCode.giftVoucherHistory(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },
    
    
};
const mutations = {};
const getters = {}

export const promocode = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};